import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { HttpClient } from '@angular/common/http';
import { AysVirtualClinicAnalysisFullyInpatientCasesExportRequest } from './export';
import { AysVirtualClinicAnalysisApi } from '../store/virtual-clinic-analysis.store';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';

@Injectable({
  providedIn: 'root',
})
export class AysVirtualClinicAnalysisFullyInpatientCasesExportService {
  private readonly _httpClient = inject(HttpClient);
  private _store: AysVirtualClinicAnalysisApi;

  constructor() {
    const environmentService = inject(BdAppEnvironmentService);
    this._store = new AysVirtualClinicAnalysisApi(environmentService.load(ApiEndpointKey.AYS_VIRTUAL_CLINIC_RESOURCE_URL));
  }

  /**
   * Starts a master export of one virtual clinic. Every request must name
   * `virtualClinicId`; the backend answers 400 otherwise.
   */
  public exportFullyInpatientCases(
    virtualClinicId: string,
    requests: AysVirtualClinicAnalysisFullyInpatientCasesExportRequest[] = [],
    filename?: string,
    labels?: string[],
  ): Observable<{
    id: string;
    userId: string;
    recipientEmail: string;
    status: 'WAITING';
    virtualClinicId: string;
    request: AysVirtualClinicAnalysisFullyInpatientCasesExportRequest[];
    createdDate: Date;
    modifiedDate: Date;
  }> {
    const url = this._store.export(virtualClinicId);
    const body: {
      requests: AysVirtualClinicAnalysisFullyInpatientCasesExportRequest[];
      fileName?: string;
      labels?: string[];
    } = {
      requests: requests,
      fileName: filename,
    };

    if (labels) {
      body.labels = labels;
    }

    return this._httpClient.post<{
      id: string;
      userId: string;
      recipientEmail: string;
      status: 'WAITING';
      virtualClinicId: string;
      request: AysVirtualClinicAnalysisFullyInpatientCasesExportRequest[];
      createdDate: Date;
      modifiedDate: Date;
    }>(url, body);
  }
}
